export const parseSolutionsOurApproachContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const section = page.sections.find((item) => item.key === 'our-approach');
  if (!section) {
    return null;
  }

  const fields = section.fields || {};

  if (!fields.title) {
    return null;
  }

  const steps = [];

  for (let index = 1; index <= 20; index += 1) {
    const title = fields[`step-${index}-title`];
    if (!title) {
      break;
    }

    steps.push({
      number: fields[`step-${index}-number`] || `${index}.`,
      title,
      description: fields[`step-${index}-description`] || '',
    });
  }

  if (steps.length === 0) {
    return null;
  }

  return {
    title: fields.title,
    steps,
  };
};
